module.exports = __webpack_public_path__ + "img/continue_left.2843a28e.svg";